import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import jwtDecode from 'jwt-decode';

import justLogo from '../images/justlogo500.png'

import RobaCard from '../components/RobaCard';
import BackLinkButton from '../components/BackLinkButton';

const CategoryPage = () => {

    const { category } = useParams();
    console.log('category: ', category);

    const token = localStorage.getItem('loggedUser');
    const decodedToken = jwtDecode(token);

    const [categoryObjects, setCategoryObjects] = useState(null);

    const getObjectsByCategory = async () => {

        try {
            const res = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/roba/category/${category}?lat=${decodedToken.position.coordinates.lat}&lng=${decodedToken.position.coordinates.lng}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })

            if (res.ok) {
                const objects = await res.json();
                setCategoryObjects(objects.payload);
            } else {
                console.log('Errore: ', res);
            }
        } catch (error) {
            console.log('Error Type: ', error)
        }
    }

    useEffect(()=> {
        getObjectsByCategory();
    }, [])

    useEffect(() => {
        console.log('categoryObjects: ', categoryObjects);
    }, [categoryObjects])

    return (
        <div className="container">

            <img src={justLogo} style={{width: '50px'}}/><h2>categoria '{category}'</h2>
            <BackLinkButton />

            <h3>Ecco gli oggetti intorno a te nella categoria {category}</h3>
            <div className="roba-box-container">
                {

                categoryObjects &&

                categoryObjects.length !== 0 && categoryObjects.map((element) => (

                    element.supplier._id !== decodedToken.id && element.available && (
                    <RobaCard key={element._id} data={element} userCoordinates={decodedToken.position.coordinates} userId={decodedToken.id}/>
                    )

                ))

                }
            </div>
        </div>
    )
}

export default CategoryPage;